<template>
<div id="mapihistory">
  <b-field class="box" position="is-centered" grouped>
    <div class="control">
      <b-taglist v-if="mid" attached>
        <b-tag type="is-dark">API</b-tag>
        <b-tag type="is-info">{{ mid }}</b-tag>
      </b-taglist>
    </div>
    <div class="control">
      <b-taglist v-if="pid" attached>
        <b-tag type="is-dark">Project</b-tag>
        <b-tag type="is-info">{{ pid }}</b-tag>
      </b-taglist>
    </div>
    <div class="control">
      <b-taglist v-if="calleruid" attached>
        <b-tag type="is-dark">调用者ID</b-tag>
        <b-tag type="is-info">{{ calleruid }}</b-tag>
      </b-taglist>
    </div>
    <div class="control">
      <b-switch v-model="myHistory" @input="onShowMine">只看我的调用历史</b-switch>
    </div>
  </b-field>
  <b-table
    :data="histories"
    detailed detail-key="record_id"
    paginated backend-pagination
    :per-page="perPage"
    :total="histories.length"
    :current-page="currentPage"
    @page-change="getRecords">
    <b-table-column #default="props" field="recordid" label="记录ID" width="80" numeric centered>
      {{ props.row.record_id }}
    </b-table-column>
    <b-table-column #default="props" field="caller" label="调用者" width="180" centered>
      {{props.row.nickname}}({{ props.row.calleruid }})
    </b-table-column>
    <b-table-column #default="props" field="mid" label="API" width="300" centered>
      {{ props.row.mname }}({{ props.row.mid }})
    </b-table-column>
    <b-table-column #default="props" field="createtime" label="创建时间" centered>
      {{ formatDateTime(props.row.createtime) }}
    </b-table-column>
    <template #bottom-left>
      <b>总计：</b>{{ histories.length }}
    </template>
    <template #detail="{row}">
      <pre class="prewrap">{{ row.note }}</pre>
    </template>
  </b-table>
</div>
</template>

<script>
import config from '@/core/config'
import cache from '@/core/cache'

export default {
  name: 'mapihistory',
  components: {},
  data () {
    return {
      perPage: config.PER_PAGE,
      currentPage: 1,
      histories: [],
      mid: null,
      pid: null,
      calleruid: null,
      myHistory: false,
      myAdminuid: null
    }
  },
  methods: {
    clear () {
      this.histories = []
      this.mid = null
      this.pid = null
      this.calleruid = null
      this.currentPage = 1
      this.perPage = config.PER_PAGE
      this.myHistory = false
      this.myAdminuid = null
    },
    genQuery () {
      const query = { }
      if (this.mid) {
        query.mid = this.mid
      }
      if (this.pid) {
        query.pid = this.pid
      }
      if (this.calleruid) {
        query.calleruid = this.calleruid
      }
      return query
    },
    setQuery ({ mid, pid, calleruid }) {
      this.mid = mid
      this.pid = pid
      this.calleruid = calleruid
    },
    onShowMine (mine) {
      if (mine) {
        const user = cache.getUser()
        if (user) {
          this.calleruid = user.uid
        }
      } else {
        this.calleruid = null
      }
      this.getRecords(1)
    },
    async getRecords (page) {
      page = page || this.currentPage || 1
      try {
        const rdata = await this.mjp.get2({
          url: '/mapi/record/get/more/',
          query: this.genQuery(),
          mjpType: 'admin'
        })
        this.histories = rdata.record
        this.perPage = rdata.per_page
        this.currentPage = rdata.page
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>
